var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-body"
  }, _vm._l((_vm.tasks), function(task, idx) {
    return _c('div', {
      key: idx,
      staticClass: "task"
    }, _vm._l((task), function(ref, idx) {
      var display = ref.display;
      var desc = ref.desc;
      var color = ref.color;
      var width = ref.width;
      var offset = ref.offset;
      var from = ref.from;
      var to = ref.to;

      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (display),
          expression: "display"
        }],
        key: idx,
        staticClass: "interval",
        style: ({
          'background-color': color,
          width: width + 'px',
          'margin-left': offset + 'px'
        }),
        attrs: {
          "title": (desc + ", 'From' " + from + " 'to' " + to)
        }
      }, [_vm._v("\n      " + _vm._s(desc) + "\n    ")])
    }))
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-271491d0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GanttBody.vue
// module id = 198
// module chunks = 1